var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1267 11L1267 39",
    stroke: "#F2DCCE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1267.5,
    cy: 6.33333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267 15L1260 11.2V5.2L1256 3L1267 -3L1278 3V11H1276V4.1L1274 5.2V11.2L1267 15ZM1267 6.7L1273.85 3L1267 -0.7L1260.15 3L1267 6.7ZM1267 12.725L1272 10.025V6.25L1267 9L1262 6.25V10.025L1267 12.725Z",
    fill: "#CC7D61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool8);
export default __webpack_public_path__ + "static/media/school_8.69f3684973a8505a5cf927d4cb371565.svg";
export { ForwardRef as ReactComponent };